import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { injectIntl, intlShape } from 'react-intl';
import * as keyboardEventHelpers from 'globals/keyboardEvents';

import { isMobile } from 'globals/utils';
import { StylePropType } from 'globals/styles';
import styles from './styles';
import messages from './messages';

class InputWithSubmit extends Component {
  constructor(props) {
    super(props);

    this._input = {
      blur: () => {},
    };
  }

  handleSubmit = () => {
    const { onSubmit, value } = this.props;

    if (this._input && isMobile()) this._input.blur();

    onSubmit(value);
  };

  handleKeyPress = event => {
    if (keyboardEventHelpers.isEnterKey(event)) {
      event.preventDefault();
      this.handleSubmit();
    }
  };

  render() {
    const { onChange, placeholder, style, value, error, intl } = this.props;
    return (
      <div style={style}>
        <input
          style={error ? Object.assign({}, styles.input, styles.submitError) : styles.input}
          type="text"
          onChange={onChange}
          value={value}
          placeholder={error || placeholder}
          onKeyPress={this.handleKeyPress}
          aria-label={intl.formatMessage(messages.aria_label_input_email)}
          className="inputWithSubmit kustomer-app-email-banner-input"
          ref={c => {
            this._input = c;
          }}
        />
        <div
          tabIndex="0"
          className="inputWithSubmitIcon kustomer-app-email-banner-icon"
          style={error ? Object.assign({}, styles.submit, styles.submitErrorIconWrap) : styles.submit}
          onClick={this.handleSubmit}
          onKeyPress={this.handleKeyPress}
          role="button"
          aria-label={intl.formatMessage(messages.aria_label_submit_email)}
        >
          <div style={error ? Object.assign({}, styles.submitIcon, styles.submitErrorIcon) : styles.submitIcon} />
        </div>
      </div>
    );
  }
}

InputWithSubmit.propTypes = {
  onChange: PropTypes.func,
  onSubmit: PropTypes.func,
  placeholder: PropTypes.string,
  style: StylePropType,
  value: PropTypes.string,
  error: PropTypes.string,
  intl: intlShape.isRequired,
};
InputWithSubmit.defaultProps = {
  onChange: () => {},
  onSubmit: () => {},
  placeholder: '',
  style: {},
  value: '',
  error: '',
};

const componentWithIntl = injectIntl(InputWithSubmit);
export default componentWithIntl;
